import React, { useState, useEffect } from 'react';

function Lightbox({ images, index, onClose, onPrev, onNext }) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  useEffect(() => {
    function handleKey(e) {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onPrev();
      if (e.key === 'ArrowRight') onNext();
    }
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [onClose, onPrev, onNext]);

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        background: 'rgba(0,0,0,0.92)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        cursor: 'pointer'
      }}
    >
      <button
        onClick={e => { e.stopPropagation(); onPrev(); }}
        style={{
          position: 'absolute', left: 20, top: '50%', transform: 'translateY(-50%)',
          background: 'rgba(255,255,255,0.2)', border: 'none', color: '#fff',
          width: 50, height: 50, borderRadius: '50%', fontSize: 24, cursor: 'pointer',
          zIndex: 10
        }}
      >
        &#8249;
      </button>

      <img
        src={images[index]}
        alt=""
        onClick={e => e.stopPropagation()}
        style={{
          maxWidth: '92%', maxHeight: '92%', objectFit: 'contain', borderRadius: 4
        }}
      />

      <button
        onClick={e => { e.stopPropagation(); onNext(); }}
        style={{
          position: 'absolute', right: 20, top: '50%', transform: 'translateY(-50%)',
          background: 'rgba(255,255,255,0.2)', border: 'none', color: '#fff',
          width: 50, height: 50, borderRadius: '50%', fontSize: 24, cursor: 'pointer',
          zIndex: 10
        }}
      >
        &#8250;
      </button>

      <button
        onClick={onClose}
        style={{
          position: 'absolute', top: 20, right: 20,
          background: 'rgba(255,255,255,0.2)', border: 'none', color: '#fff',
          width: 50, height: 50, borderRadius: '50%', fontSize: 28, cursor: 'pointer',
          zIndex: 10
        }}
      >
        &times;
      </button>

      <div
        style={{
          position: 'absolute', bottom: 20, color: '#fff',
          fontSize: 14, background: 'rgba(0,0,0,0.5)', padding: '6px 16px', borderRadius: 20
        }}
      >
        {index + 1} / {images.length}
      </div>
    </div>
  );
}

export default Lightbox;
